import { useState } from 'react'
import { Button, Divider, Grid } from '@mui/material';
import globalStyles from "../../../../../assets/styles/global.module.scss"
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import TableFormatView from './tableFormatView';
import styles from '../../../../../assets/styles/componentStyles/widgetComponentStyles/tableFormat.module.scss'
import { primaryColor } from '../../../../../utils/colors';

const TableFormatGlobal = (props: any) => {
    const { data, chatbotTheme, threadId, fields } = props;
    const [flagModal, setFlagModal] = useState(false)
    const [modalData, setModalData] = useState("")
    const [childData, setChildData] = useState(null) //this is to show details of a particular cell when clicked

    // function showModal(data, actionTypeId) {
    //     if (actionTypeId == 8.2) {
    //         setModalData({
    //             actionTypeId: 8.2,
    //             data: data
    //         })
    //     } else {
    //         setModalData(data.url)
    //     }
    //     setFlagModal(true)
    // }

    function handleActionButton(action: any) {
        let actionTypeId = action.message_format_id
        switch (actionTypeId) {
            case 1:
                if (action && action.message_fields.child_data) {
                    setChildData(action.message_fields.child_data)
                }
                break
            // case 4:
            //     return showModal(action.message_fields, actionTypeId)
            // case 3:
            //     return window.open(action.message_fields.url, "_blank");
            // case 8.2:
            //     return showModal(action.message_fields, actionTypeId)
            // case 11:
            //     return props.handleRecursion(action.message_fields, true)

            default:
                return
        }
    }

    function closePopup() {
        setModalData("")
        setFlagModal(false)
    }
    function isMessageFormat1HasChild(action: any) {
        if (action && action.message_fields.child_data) return true
        return false
    }

    const handleMessageFormat = (thread: any) => {
        let errorMessage = "Something went wrong! Please try again."
        if (thread.message_format_id == 1) {
            if (thread?.message_fields?.message) {
                if (Array.isArray(thread?.message_fields?.message)) {
                    return <div
                        className={isMessageFormat1HasChild(thread) ? globalStyles.clickable : ""}
                        onClick={() => {
                            if (isMessageFormat1HasChild(thread)) {
                                handleActionButton(thread)
                            }
                        }
                        }
                    >
                        {JSON.stringify(thread?.message_fields?.message.join("&nbsp;"))}
                    </div>
                } else {
                    return <div
                        onClick={() => {
                            if (isMessageFormat1HasChild(thread)) {
                                handleActionButton(thread)
                            }
                        }
                        }
                        className={isMessageFormat1HasChild(thread) ? globalStyles.clickable : ""}
                    >{thread?.message_fields?.message ?? errorMessage}</div>
                }
            } else {
                return errorMessage
            }
        }
        else if (thread.message_format_id == 2) {
            return (thread?.message_fields?.additional_text_message?.toString() || thread?.additional_text_message?.toString() || errorMessage)
        }
        else if (thread.message_format_id == 3) {
            return thread?.message_fields?.url_text ?
                <Button
                    onClick={() => handleActionButton(thread)}
                    sx={{
                        backgroundColor: chatbotTheme?.chatbot_header_color ? `${chatbotTheme?.chatbot_header_color} !important` : `${primaryColor} !important`,
                        color: chatbotTheme?.chatbot_header_font_color ? `${chatbotTheme?.chatbot_header_font_color} !important` : "#FFFFFF !important",
                        padding: "6px 20px 5px !important",
                        fontSize: "12px !important"
                    }}
                >
                    {thread?.message_fields?.url_text}
                </Button>
                :
                errorMessage
        }
        else if (thread.message_format_id == 4) {
            return <span
                onClick={() => handleActionButton(thread)}
                style={{
                    color: chatbotTheme?.chatbot_header_color ? `${chatbotTheme?.chatbot_header_color} !important` : `${primaryColor} !important`,
                    fontStyle: "italic"
                }}
            >
                {thread?.message_fields?.url_text ?? errorMessage}
            </span>
        }
        else if (Math.trunc(thread.message_format_id) == 5 || Math.trunc(thread.message_format_id) == 6 || Math.trunc(thread.message_format_id) == 7 || Math.trunc(thread.message_format_id) == 9 || Math.trunc(thread.message_format_id) == 10 || Math.trunc(thread.message_format_id) == 12 || Math.trunc(thread.message_format_id) == 13 || Math.trunc(thread.message_format_id) == 15 || Math.trunc(thread.message_format_id) == 16) {
            return thread?.message_reply_text ?? errorMessage
        }
        else {
            return ((thread.message) ? thread.message : "") + " " + ((thread.additional_text_message) ? thread?.additional_text_message : "")
        }
    }
    // useEffect(() => {
    //     if (chatBotDetail && data.message_format_id == 16.3) {
    //         if (chatBotDetail.chatbot_thread[chatBotDetail.chatbot_thread.length - 1].chatbot_thread_id === threadId && withinSeconds(chatBotDetail.chatbot_thread.at(-1).created_at_timestamp)) {
    //             setFlagTableInsidePopup(true)
    //         }
    //         else {
    //             setFlagTableInsidePopup(false)
    //         }
    //     }
    // }, [])
    return (
        <>
            <Grid item sx={{ padding: "8px 0px" }} mt={"4px"}>
                {data.message_format_id == 16.2 &&
                    <>
                        <TableFormatView fields={fields} handleMessageFormat={handleMessageFormat} chatbotTheme={chatbotTheme} childData={childData} />
                    </>
                }
                {data.message_format_id == 16.3 && //only cell data with message format 1 or 4, cases where there is nopopup
                    <Grid item>
                        <Grid container direction={"column"} className={styles.table_format_popup_style}>
                            <Grid item>
                                <Grid container direction={"column"} gap={"6px"}>
                                    {
                                        <Grid item>
                                            <Grid container flexWrap={"nowrap"} gap={"6px"}>
                                                {childData &&
                                                    <Grid item>
                                                        <KeyboardBackspaceIcon onClick={() => setChildData(null)} sx={{ cursor: "pointer" }} />
                                                    </Grid>}
                                                <Grid item>
                                                    <span className={styles.table_name_heading_style}>{data?.message_fields?.title}</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>

                            <Divider />

                            <Grid item sx={{ width: "100%" }}>
                                <TableFormatView fields={fields} handleMessageFormat={handleMessageFormat} chatbotTheme={chatbotTheme} childData={childData} />
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </>
    )
}

export default TableFormatGlobal
